//
//
//
//
//
//
//
//
//
//
//

import {CheckLoginIn} from './utils/login'
import { SetConfig } from './utils/wx'
import {Save} from "./utils/storage"
export default {
    name: 'app',
    async mounted() {
        await CheckLoginIn()
        if(process.env.VUE_APP_ENVIRONMENT !=='development'){
            await SetConfig(window.location.href, [
                'onMenuShareTimeline',
                'onMenuShareAppMessage'
            ])
        }
    },
    async beforeCreate() {
        if (process.env.VUE_APP_ENVIRONMENT === 'development') {
            if (this.$route.query["username"] == "zhangxiang21") {
                Save("Token", "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJRCI6MywiT3BlbklEIjoib1I4Rkowb0dGamhFdDh3d3ZxR0x0WUl5MVoxOCIsIlRpbWUiOjE1NjM0NjgwNzIsImV4cCI6NjA0ODAwMDAwMDAwMDAwfQ.nmCVqouNG_CCwAnZsvhkUT7K7jdVOKB_LK3p9dgCRLA")
            } else if (this.$route.query["username"] == "dengjun") {
                Save("Token", "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJRCI6NywiT3BlbklEIjoib1I4Rkowbnl3ZDFUSktzelNqWGU1UDY2ZVhpRSIsIlRpbWUiOjE2NDcwNzAyODEsImV4cCI6NjA0ODAwMDAwMDAwMDAwfQ.ShfL01pMbph7RS_bjWGu77RxApgQx4QnScYShn_jatk")
            } else if (this.$route.query["username"] == "yuanfuren") {
                Save("Token", "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJRCI6OCwiT3BlbklEIjoib1I4RkowckxpeXZNd3E5WVJzbDljZTRsVGsxTSIsIlRpbWUiOjE2NDcwNzAyODEsImV4cCI6NjA0ODAwMDAwMDAwMDAwfQ.Ll7YERHPeUso3E3IiWA9kbLRfkAX4jnbH4qfyZcVFXk")
            } else if (this.$route.query["username"] == "chenpeipei") {
                Save("Token", "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJRCI6OSwiT3BlbklEIjoib1I4RkowaTdOdHFvN2dQMHBxSWFMUVVUeGtyVSIsIlRpbWUiOjE2NDcwNzAyODEsImV4cCI6NjA0ODAwMDAwMDAwMDAwfQ.wv8kfb1nv68XgW-7TZmJKHKV_kaqWCIOCbbSiNECGaI")
            } else {
                Save("Token", "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJRCI6MywiT3BlbklEIjoib1I4Rkowb0dGamhFdDh3d3ZxR0x0WUl5MVoxOCIsIlRpbWUiOjE1NjM0NjgwNzIsImV4cCI6NjA0ODAwMDAwMDAwMDAwfQ.nmCVqouNG_CCwAnZsvhkUT7K7jdVOKB_LK3p9dgCRLA")
            }
        }
    },
    data () {
        return {
            transitionName: 'slide-right',
        }
    },
    watch: {
        '$route' (to, from) {
            const toDepth = to.path.split('/').length
            const fromDepth = from.path.split('/').length
            if (toDepth === fromDepth) {
                this.transitionName = 'fade'
            } else if (toDepth > fromDepth) {
                this.transitionName = 'slide-left'
            } else {
                this.transitionName = 'slide-right'
            }
        }
    }

}
